import React from "react";

import "../../css/admin/utils/radio-select.scss";

import type { JSX } from "react";

interface RadioSelectProps {
  selected: number;
  options: { key: number; value: string }[];
  onChange: (key: number) => void;
}

function RadioSelect({
  options,
  selected,
  onChange,
}: RadioSelectProps): JSX.Element {
  return (
    <div className="radio-select-container">
      {options.map((option) => (
        <div
          key={`radio-select-option-${option.key}`}
          className={`radio-select-option ${selected === option.key ? "selected" : ""}`}
          onClick={(): void => onChange(option.key)}
        >
          {option.value}
        </div>
      ))}
    </div>
  );
}

export default RadioSelect;
